<template>
  <div>
    <div class="container">
      <div class="left">
       
        <div style="padding: 0 " v-loading = 'baseBOMLoading'>
          <vxe-grid ref="xGrid" row-id="serial" v-bind="gridOptions" height="470" >
            <!-- <template #getDynamic="{ row,columnIndex,column}">
              <span v-for="(item,index) in getDynamicData(row,columnIndex-1,column)" class="showLink" :key="index" :title="item.label" @click="clax(item)"> {{ item.label }}</span>
            </template> -->
          </vxe-grid>
        </div>
      </div>
      
    </div>
    <div class="button">
      <p style="color:#fff">swift</p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {itemTabList} from "@/utils/publicstate";
export default {
  data() {
    return {
      checkList: [],
      isCreate:1,
      BOMLists: [],
      BOMSelected: "",
      BOMTitle:'...BOM',

      tempList:[],

      gridOptions: {
        resizable: true,
        border: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,

        rowId: "id",
        height: "470",
        size: "small",
        columns: [],
        data: [],
        exportConfig: {},
        toolbarConfig: {
          export:true,
          // zoom: true,
          // custom: true,
          // slots: {
          //   buttons: "toolbar_buttons",
          // },
        },
        treeConfig: {
          lazy: true,
          children: "children",
          hasChild: "hasChildren",
        },
        sortConfig: {
          trigger: "cell",
        },
        
      },
      copyBOMGridOptions: {
        resizable: true,
        border: true,
        columns: {},
        data: [],
        showHeaderOverflow: true,
        showOverflow: true,
        rowId: "id",
        treeConfig: {
          lazy: true,
          children: "children",
          hasChild: "hasChildren",
        },
      },
      objId: {
        ... this.$store.state.objectId,
      },
      baseBOMLoading:false,
      moreBOMLoading:false
    };
  },
  props: {
    baseGridOptions: {
      required: true,
      type: Object,
    },
    BOMType:{
      type: Number,
      require:true
    }
  },
  methods: {

    // getDynamicData(row, columnIndex, column) {

    //   const nCol = this.gridOptions.columns[columnIndex + 1].uiType;
    //   const options = this.gridOptions.columns[columnIndex + 1].editRender.options;

    //   const val = row[column['field']];

    //   if (nCol === 3) {
    //     return options.filter(i => i.value === val || i.label === val)
    //   } else {
    //     return !val ? [] : options.filter(i => val.includes(i.value) || val.includes(i.label))
    //   }
    // },

    // editActivedEvent({ row, columnIndex, column }) {

    //   const nCol = this.gridOptions.columns[columnIndex];
    //   console.log(nCol);
    //   if (nCol.listType === 3) {
    //     axios.get('pmdm/admin/list/getEnabledListEntryByListId?listId=' + nCol.listId).then(res => {
    //       nCol.editRender.options = res.data.object.listEntries.map(i => ({ value: i.listId + '_' + i.entryId, label: i.entryValue }))
    //     })
    //   }
    // },

    // clax(item) {

    //   axios.get('pmdm/admin/list/getObjectInfoByListId?listEntryId=' + item.value).then(res => {
    //     const obj = { ...res.data.object, title: item.label };
    //     this.getLink(obj);
    //     this.$store.commit('setPageRefresh');
    //   })
    // },


    getData() {

      var obj_get = {
        rootId:this.$store.state.objectId.id,
        changeId:this.$store.state.change_info.changeId,
        bomType:this.BOMType
      };
      axios
        .get(`/pmdm/MultipleBom/getMultipleBomFromOldBom${this.params(obj_get)}`).then(
          res => {
            console.log(res);
            const {rows,columnInfo} = res.data.object.table;

            const tt = columnInfo.columns.map((i,e) => ({
              field:i,
              title:columnInfo.names[e]
            }))

            this.gridOptions.columns = tt;


            this.gridOptions.data = this.formatData(rows);
            console.log(this.gridOptions.data);
          }
        )
        // this.baseBOMLoading = false  
    },

    selectAllEvent({$table,checked}){
      let arr = this.getAllRow(this.gridOptions.data);
      for (var row of arr) {
        $table.setCheckboxRow(row, checked);
      }
    },
    setCheck({ $table }){
      let arr = this.$refs.xGrid.getCheckboxRecords();
      arr.map(i => {
        if (arr.some(j => j.serial == i.grandParentSerial)) {
          const row = this.getAllRow(this.gridOptions.data).find(k =>k.serial == i.parentSerial );
          $table.setCheckboxRow([row], true);
        }
      })
    },
   
    formatData(arr,level,parentRowId) {
      let newArr = [];
      let serial = level || "";
      parentRowId = parentRowId || "";
      arr.map((i,e) => {

        const s = e + 1 + "";
        let n = {
          rowId : i.rowId,
          parentRowId : !parentRowId ? i.rowId : parentRowId +";"+ i.rowId,
          grandParentSerial : !serial.includes(".") ? '' : serial.substring(0,serial.lastIndexOf('.')),
          serial : !serial ? s : serial + "." + s,
          parentSerial : serial
        };

        i.cells.map((j,e) =>{
          const val = j?.val || ''
          Object.assign(n,{[this.gridOptions.columns[e].field]:val})
        });
        newArr.push(n);
        n.children = !i.children ? [] : this.formatData(i.children,n.serial,n.parentRowId);
      });
      return newArr;
    },

  },
  created() {
    // console.log(1111);
    // this.gridOptions.columns = [...this.baseGridOptions.columns];
    // this.gridOptions.columns.shift();
    // this.gridOptions.columns.map(i => {
    //   i.slots = {}
    // })
    // console.log(this.gridOptions.columns);
    this.getData()
  },
};
</script>

<style scoped>
.checkbox-group{
  height: 32px;
  line-height: 32px;
  display: inline-block;
  margin-left: 35px;
  margin-bottom: 5px;
}
.content {
  border: 1px solid steelblue;
}
.container {
  width: 100%;
  display: flex;
  flex-wrap: warp;
  justify-content : flex-start;
  /* overflow: hidden; */
  /* border: 1px solid steelblue; */
}
.container  {
  background-color: #fff;
  margin-right: 10px; 
  float: left;
  width: 100%;
}

.left {
  width: 100%;
  height: 500px;
  /* border-right: 1px solid steelblue; */
  display: inline;
  /* float: left; */
}
.mid-button {
  width: 8%;
  height: 500px;
  /* display: inline; */
  /* margin: 0 5px; */
  display: flex;/*父元素设置flex属性*/
    justify-content: center;/*水平主轴居中*/
    align-items: center;/*垂直交叉轴居中*/
} 
.center-button{
  margin: auto;
}

.right {
  width: 46%;
  height: 500px;
  /* display: inline; */
}
.button {
  margin: auto;
  /* height: 15px; */
}
.BOM-title{
  display: inline;
  font-size: 16px;
  color: #409EFF;
}

</style>
